import * as React from 'react';
import { ArticleHeading2, ArticleHeading4 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IReviewPopupMobileProps {
  title: string;
  review: React.ReactNode;
  answersCount: string;
  answers: React.ReactNode;
  close(): void;
}

export const ReviewPopupMobile = ({
  title,
  close,
  review,
  answers,
  answersCount,
}: IReviewPopupMobileProps): React.JSX.Element => {
  return (
    <div data-testid="ReviewPopupMobile" className={styles['container']}>
      <div className={styles['header']}>
        <ArticleHeading4>{title}</ArticleHeading4>
        <button className={styles['close']} onClick={close}>
          <IconActionClose16 />
        </button>
      </div>
      <div className={styles['content']}>
        {review}
        <div className={styles['counter']}>
          <ArticleHeading2>{answersCount}</ArticleHeading2>
        </div>
        {answers}
      </div>
    </div>
  );
};
